import { c as _c } from "react/compiler-runtime";
import { useCssVariable } from '@shared/utils/hooks/use-css-variable';
import { useBreakpoint } from './use-breakpoint';

// this hooks returns a dynamic --container-spacing-inline css variable value for usage in JS. It refreshes the value on breakpoint change.

export const useContainerSpacingInline = () => {
  const $ = _c(4);
  const {
    breakpoint
  } = useBreakpoint();
  let t0;
  if ($[0] !== breakpoint) {
    t0 = {
      dependencies: [breakpoint]
    };
    $[0] = breakpoint;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [containerSpacingInlineCssVariable] = useCssVariable("--container-spacing-inline", t0);
  let t1;
  if ($[2] !== containerSpacingInlineCssVariable.propertyValue) {
    t1 = Number.parseInt(containerSpacingInlineCssVariable.propertyValue, 10);
    $[2] = containerSpacingInlineCssVariable.propertyValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};